var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLayoutLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3813_7383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 1.33301V14.6663M3.99992 14.6663H11.9999C13.4727 14.6663 14.6666 13.4724 14.6666 11.9997V3.99967C14.6666 2.52692 13.4727 1.33301 11.9999 1.33301H3.99992C2.52716 1.33301 1.33325 2.52692 1.33325 3.99967V11.9997C1.33325 13.4724 2.52716 14.6663 3.99992 14.6663Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3813_7383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLayoutLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_layout_light.5e388e8a9ae013477dd4e971ce6d6da2.svg";